// Free sample files for the indexed Real Books (Dropbox direct downloads)
// plus the localized copy for the "Try a free sample" cards.

export var SAMPLE_FILES = {
  forscore: {
    url: 'https://www.dropbox.com/scl/fi/lumrzhtf1xd1n66fn7x4q/Test-sample-Real-Book-Vol-1-in-Bb.4sc?rlkey=w6uhnesolox6uzfi8b3voszm1&dl=1',
    filename: 'Test-sample-Real-Book-Vol-1-in-Bb.4sc',
    appName: 'forScore',
    ext: '.4sc',
  },
  mobilesheets: {
    url: 'https://www.dropbox.com/scl/fi/w01y37d9mdusofyfl09nx/Test-Real-Book-in-Bb-MobileSheets.msf?rlkey=njdoag0dvmaftqw7w73yhaxfi&dl=1',
    filename: 'Test-Real-Book-in-Bb-MobileSheets.msf',
    appName: 'MobileSheets',
    ext: '.msf',
  },
};

// Songs included in the sample — customers use these to test the search.
export var SAMPLE_SONGS = [
  'African Flower (Duke Ellington)',
  'Afro Blue (Mongo Santamaria)',
  'Afternoon In Paris (John Lewis)',
  'Airegin (Sonny Rollins)',
  'Alice In Wonderland (Sammy Fain)',
  'All Blues (Miles Davis)',
  'All In Love Is Fair (Stevie Wonder)',
  'All My Tomorrows (Jimmy Van-Heusen)',
  'All Of Me (Gerald Marks)',
  'All Of You (Cole Porter)',
  'All The Things You Are (Jerome Kern)',
  'Alone Together (Arthur Schwartz)',
  'Ana Maria (Wayne Shorter)',
  'And Now The Queen (Carla Bley)',
  'And On The Third Day (Michael Gibbs)',
  'Angel Eyes (Matt Dennis)',
  'Anthropology (Charlie Parker)',
  'April In Paris (Vernon Duke)',
  'April Joy (Pat Metheny)',
  'Arise, Her Eyes (Steve Swallow)',
  'Armageddon (Wayne Shorter)',
  'Around Again (Carla Bley)',
  'A Call For All Demons (Sun Ra)',
  'A Child Is Born (Thad Jones)',
  'A Family Joy (Michael Gibbs)',
  'A Fine Romance (Jerome Kern)',
  'A Foggy Day (George Gershwin)',
  'A Night In Tunisia (Dizzy Gillespie)',
];

var COPY = {
  en: {
    kicker: 'Free sample — no signup',
    title: 'Not sure what an “indexed” file is? Try one free.',
    subtitle: 'Download the free sample Real Book (Vol. 1 in Bb) and open it in {app}. Every song title is a bookmark and appears in the table of contents — search a tune and you are on the chart.',
    download: 'Download free {app} sample ({ext})',
    howTitle: 'How to use it',
    forscoreSteps: [
      'Download the file and import it into forScore.',
      'Open the file in the app, then tap the bookmarks list.',
      'Search any song title — the chart opens instantly.',
    ],
    mobilesheetsSteps: [
      'Download the file and open it with MobileSheets.',
      'Create a library first if you like to keep your books separate.',
      'Search any song title in the library — the chart opens instantly.',
    ],
    songsTitle: 'Songs in this sample — try searching them',
    showSongs: 'Show the 28 song titles',
    hideSongs: 'Hide song titles',
    compactTitle: 'Try a free sample first',
    compactBody: 'Download the free sample file for {app} and test the search before you buy.',
    seeMore: 'See how it works',
  },
  es: {
    kicker: 'Muestra gratis — sin registro',
    title: '¿No sabes qué es un archivo “indexado”? Pruébalo gratis.',
    subtitle: 'Descarga la muestra gratuita del Real Book (Vol. 1 en Bb) y ábrela en {app}. Cada título es un marcador y aparece en el índice — busca un tema y aparece la partitura.',
    download: 'Descargar muestra gratis de {app} ({ext})',
    howTitle: 'Cómo usarlo',
    forscoreSteps: [
      'Descarga el archivo e impórtalo en forScore.',
      'Abre el archivo en la app y toca la lista de marcadores.',
      'Busca cualquier título — la partitura se abre al instante.',
    ],
    mobilesheetsSteps: [
      'Descarga el archivo y ábrelo con MobileSheets.',
      'Crea una biblioteca primero si quieres separar los libros.',
      'Busca cualquier título en la biblioteca — la partitura se abre al instante.',
    ],
    songsTitle: 'Temas incluidos en la muestra — pruébalos en la búsqueda',
    showSongs: 'Ver los 28 títulos',
    hideSongs: 'Ocultar títulos',
    compactTitle: 'Prueba primero una muestra gratis',
    compactBody: 'Descarga el archivo de muestra para {app} y prueba la búsqueda antes de comprar.',
    seeMore: 'Ver cómo funciona',
  },
  ja: {
    kicker: '無料サンプル — 登録不要',
    title: '「インデックス付き」ファイルとは？無料でお試しください。',
    subtitle: '無料サンプルの Real Book（Vol. 1 in Bb）をダウンロードして {app} で開いてください。すべての曲名がブックマークと目次に登録されているので、検索すればすぐに譜面が開きます。',
    download: '{app} の無料サンプルをダウンロード（{ext}）',
    howTitle: '使い方',
    forscoreSteps: [
      'ファイルをダウンロードして forScore にインポートします。',
      'アプリでファイルを開き、ブックマーク一覧をタップします。',
      '曲名を検索すると、譜面がすぐに開きます。',
    ],
    mobilesheetsSteps: [
      'ファイルをダウンロードして MobileSheets で開きます。',
      '本を分けて管理したい場合は、先にライブラリを作成してください。',
      'ライブラリで曲名を検索すると、譜面がすぐに開きます。',
    ],
    songsTitle: 'サンプル収録曲 — 検索してお試しください',
    showSongs: '28曲のタイトルを表示',
    hideSongs: 'タイトルを隠す',
    compactTitle: 'まずは無料サンプルをお試しください',
    compactBody: '{app} 用の無料サンプルをダウンロードして、購入前に検索機能をお試しください。',
    seeMore: '使い方を見る',
  },
  de: {
    kicker: 'Kostenlose Probe — ohne Anmeldung',
    title: 'Unsicher, was eine „indexierte“ Datei ist? Testen Sie es gratis.',
    subtitle: 'Laden Sie das kostenlose Real-Book-Beispiel (Vol. 1 in B) herunter und öffnen Sie es in {app}. Jeder Songtitel ist ein Bookmark und steht im Inhaltsverzeichnis — Titel suchen, Noten erscheinen.',
    download: 'Kostenlose {app}-Probe herunterladen ({ext})',
    howTitle: 'So funktioniert es',
    forscoreSteps: [
      'Datei herunterladen und in forScore importieren.',
      'Datei in der App öffnen, dann die Bookmark-Liste antippen.',
      'Beliebigen Songtitel suchen — die Noten öffnen sich sofort.',
    ],
    mobilesheetsSteps: [
      'Datei herunterladen und mit MobileSheets öffnen.',
      'Legen Sie zuerst eine Bibliothek an, wenn Sie Bücher trennen möchten.',
      'Songtitel in der Bibliothek suchen — die Noten öffnen sich sofort.',
    ],
    songsTitle: 'Songs in dieser Probe — einfach mal suchen',
    showSongs: 'Die 28 Titel anzeigen',
    hideSongs: 'Titel ausblenden',
    compactTitle: 'Erst kostenlos testen',
    compactBody: 'Laden Sie die kostenlose Beispieldatei für {app} und testen Sie die Suche vor dem Kauf.',
    seeMore: 'So funktioniert es',
  },
  fr: {
    kicker: 'Échantillon gratuit — sans inscription',
    title: 'Vous ne savez pas ce qu’est un fichier « indexé » ? Essayez gratuitement.',
    subtitle: 'Téléchargez l’échantillon gratuit du Real Book (Vol. 1 en Sib) et ouvrez-le dans {app}. Chaque titre est un signet et figure dans la table des matières — cherchez un morceau, la partition s’ouvre.',
    download: 'Télécharger l’échantillon {app} gratuit ({ext})',
    howTitle: 'Comment l’utiliser',
    forscoreSteps: [
      'Téléchargez le fichier et importez-le dans forScore.',
      'Ouvrez le fichier dans l’app, puis touchez la liste des signets.',
      'Cherchez un titre — la partition s’ouvre immédiatement.',
    ],
    mobilesheetsSteps: [
      'Téléchargez le fichier et ouvrez-le avec MobileSheets.',
      'Créez d’abord une bibliothèque si vous souhaitez séparer vos recueils.',
      'Cherchez un titre dans la bibliothèque — la partition s’ouvre immédiatement.',
    ],
    songsTitle: 'Morceaux inclus dans l’échantillon — essayez la recherche',
    showSongs: 'Afficher les 28 titres',
    hideSongs: 'Masquer les titres',
    compactTitle: 'Essayez d’abord un échantillon gratuit',
    compactBody: 'Téléchargez le fichier d’exemple pour {app} et testez la recherche avant d’acheter.',
    seeMore: 'Voir comment ça marche',
  },
  it: {
    kicker: 'Campione gratuito — senza registrazione',
    title: 'Non sai cosa sia un file “indicizzato”? Provalo gratis.',
    subtitle: 'Scarica il campione gratuito del Real Book (Vol. 1 in Sib) e aprilo in {app}. Ogni titolo è un segnalibro e compare nell’indice — cerchi un brano e la parte si apre.',
    download: 'Scarica il campione {app} gratuito ({ext})',
    howTitle: 'Come si usa',
    forscoreSteps: [
      'Scarica il file e importalo in forScore.',
      'Apri il file nell’app, poi tocca l’elenco dei segnalibri.',
      'Cerca un titolo qualsiasi — la parte si apre subito.',
    ],
    mobilesheetsSteps: [
      'Scarica il file e aprilo con MobileSheets.',
      'Crea prima una libreria se vuoi tenere separati i volumi.',
      'Cerca un titolo nella libreria — la parte si apre subito.',
    ],
    songsTitle: 'Brani nel campione — prova a cercarli',
    showSongs: 'Mostra i 28 titoli',
    hideSongs: 'Nascondi i titoli',
    compactTitle: 'Prova prima un campione gratuito',
    compactBody: 'Scarica il file di esempio per {app} e prova la ricerca prima di acquistare.',
    seeMore: 'Scopri come funziona',
  },
  uk: {
    kicker: 'Безкоштовний зразок — без реєстрації',
    title: 'Не знаєте, що таке «індексований» файл? Спробуйте безкоштовно.',
    subtitle: 'Завантажте безкоштовний зразок Real Book (Vol. 1 in Bb) та відкрийте його в {app}. Кожна назва — це закладка, яка також є у змісті: шукайте пісню й одразу відкривається партія.',
    download: 'Завантажити безкоштовний зразок для {app} ({ext})',
    howTitle: 'Як користуватися',
    forscoreSteps: [
      'Завантажте файл та імпортуйте його у forScore.',
      'Відкрийте файл у застосунку й торкніться списку закладок.',
      'Знайдіть будь-яку назву — партія відкриється миттєво.',
    ],
    mobilesheetsSteps: [
      'Завантажте файл і відкрийте його в MobileSheets.',
      'Спочатку створіть бібліотеку, якщо хочете тримати збірки окремо.',
      'Шукайте назву в бібліотеці — партія відкриється миттєво.',
    ],
    songsTitle: 'Пісні у зразку — спробуйте знайти їх',
    showSongs: 'Показати 28 назв',
    hideSongs: 'Сховати назви',
    compactTitle: 'Спершу спробуйте безкоштовний зразок',
    compactBody: 'Завантажте зразок для {app} і перевірте пошук перед покупкою.',
    seeMore: 'Як це працює',
  },
};

export function sampleCopy(language) {
  return COPY[language] || COPY.en;
}

// True for the Real Book / New Real Book / Real Christmas Book products that
// the sample file actually represents.
export function hasSampleFile(product) {
  var slug = ((product && product.slug) || '').toLowerCase();
  if (!slug) return false;
  return slug.indexOf('real-book') !== -1
    || slug.indexOf('new-real-book') !== -1
    || slug.indexOf('real-christmas') !== -1;
}

export function samplePlatform(product) {
  var slug = ((product && product.slug) || '').toLowerCase();
  if ((product && product.platform) === 'mobilesheets' || slug.indexOf('mobilesheets') === 0) return 'mobilesheets';
  return 'forscore';
}
